export function formatDateTimeWithOffset(now: Date): string | null {
  const isoWithoutZ = now.toISOString().slice(0, -1);  // Remove the 'Z' (e.g., "2025-12-02T03:30:24.605")
  const offsetMinutes = now.getTimezoneOffset();  // Minutes to subtract from UTC (positive for behind UTC)
  const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
  const offsetMins = Math.abs(offsetMinutes) % 60;
  const sign = offsetMinutes > 0 ? '-' : '+';  // Negative offset means ahead of UTC
  const offsetString = `${sign}${offsetHours.toString().padStart(2, '0')}:${offsetMins.toString().padStart(2, '0')}`;

  return isoWithoutZ + offsetString;
}

export function isToday (date: Date): boolean {
  const today = new Date();
  return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
}
